// extracted by mini-css-extract-plugin
export var entityChip = "_sn-0";
export var entityChipMissing = "_sn-1";